import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["expandIcon", "expandedRow", "lyricsModal", "lyricsModalTitle", "lyricsModalContent"]

  toggleExpand(event) {
    const row = event.currentTarget
    const trackId = row.dataset.trackId

    // Find the corresponding expanded row
    const expandedRow = this.expandedRowTargets.find(
      el => el.dataset.expandedTrackId === trackId
    )

    // Find the corresponding icon
    const icon = row.querySelector('[data-track-preview-target="expandIcon"]')

    if (expandedRow && icon) {
      // Toggle the expanded row visibility
      expandedRow.classList.toggle('hidden')

      // Rotate the icon
      if (expandedRow.classList.contains('hidden')) {
        icon.classList.remove('rotate-180')
      } else {
        icon.classList.add('rotate-180')
      }
    }
  }

  openLyricsModal(event) {
    event.stopPropagation()
    const button = event.currentTarget
    const lyrics = button.dataset.lyrics
    const trackTitle = button.dataset.trackTitle

    // Set the modal title
    this.lyricsModalTitleTarget.textContent = `Lyrics - ${trackTitle}`

    // Set the lyrics content (decode HTML entities)
    const textarea = document.createElement('textarea')
    textarea.innerHTML = lyrics
    this.lyricsModalContentTarget.textContent = textarea.value

    // Show the modal
    this.lyricsModalTarget.classList.remove('hidden')
  }

  closeLyricsModal() {
    this.lyricsModalTarget.classList.add('hidden')
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
